/**
 * Ensures jQuery is globally available and the Telerik Report Viewer's
 * Kendo subset (kendoToolBar, etc.) is registered as jQuery plugins.
 *
 * Import this module BEFORE importing TelerikReportViewer in any component.
 *
 * Why this is needed:
 * The Report Viewer's initExtDeps.js checks `if (!window.kendo)` before
 * loading its custom Kendo build. If another package sets window.kendo first
 * (without registering the jQuery plugins), kendoToolBar won't be available
 * and the viewer will crash with "kendoToolBar is not a function".
 */
import jQuery from 'jquery';

// Set jQuery globally so the Kendo subset can find it and register plugins
(window as any).jQuery = jQuery;
(window as any).$ = jQuery;

// Force-load the Telerik Report Viewer's bundled Kendo subset.
// This registers $.fn.kendoToolBar and other required jQuery plugins.
// eslint-disable-next-line @typescript-eslint/no-require-imports
require('@progress/telerik-react-report-viewer/dist/dependencies/telerikReportViewer.kendo.min');
